import * as React from 'react'

import { Box, Checkbox, Table } from '@factorialco/deprecated-design-system'

import { type Users } from 'modules/core/store/collections/users'

import { useTableContext } from 'modules/employees/pages/ImportProcessPage/components/ImportProcessWizard/EditionStep/context'
import { type Employees } from 'modules/employees/store/collections/employees'

import EditableCell from './EditableCell'

interface RowsWrapperProps {
  index: number
  style: React.CSSProperties
  employees: Employees
  users: Users
}

const RowsWrapper = ({ index, style, employees, users }: RowsWrapperProps) => {
  const {
    rows,
    rowsWithError,
    enumOptions,
    onCellChange,
    onCellClicked,
    focusedCell,
    toggleSelectRow,
    mappings,
    fields,
    tableHeadRef,
  } = useTableContext()

  if (!rows || !rows[index]) return null
  if (!(enumOptions && onCellChange && onCellClicked && focusedCell)) return null

  const row = rows[index]

  const cellField = (cellIndex: number) => {
    const [field] = (mappings || []).filter((mappedField) => mappedField.columnIndex === cellIndex)
    return fields?.find((x) => x.fieldName === field?.fieldName)
  }

  if (!row) return null

  const rowIndex = row.index !== undefined ? row.index : -1
  const headerHeight = tableHeadRef?.current?.getBoundingClientRect()?.height || 0
  const rowTop = +(style.top || 0) + headerHeight

  return (
    <Table.Row
      style={{ ...style, top: rowTop }}
      background={rowsWithError?.includes(rowIndex) ? 'radicalRed100' : undefined}
    >
      <Table.Cell padding="s0" width={40}>
        <Box justifyContent="center" flexDirection="row">
          <Checkbox
            checked={row.selected}
            onChange={() => toggleSelectRow && toggleSelectRow(index)}
          />
        </Box>
      </Table.Cell>
      {row.cells?.map(
        (cell, columnIndex) =>
          cell !== undefined && (
            <Table.Cell key={columnIndex} padding="s0" width={240}>
              <EditableCell
                fieldType={cellField(columnIndex)?.fieldType || ''}
                cell={cell}
                isFocused={
                  focusedCell.rowIndex === rowIndex && focusedCell.columnIndex === columnIndex
                }
                originalRowIndex={rowIndex}
                columnIndex={columnIndex}
                onCellClicked={onCellClicked}
                enumOptions={enumOptions(cellField(columnIndex)?.fieldName || '')}
                onChange={onCellChange}
                mandatory={cellField(columnIndex)?.required ?? false}
                rowWithError={rowsWithError?.includes(rowIndex)}
                employees={employees}
                users={users}
              />
            </Table.Cell>
          )
      )}
    </Table.Row>
  )
}

export default RowsWrapper
